export type ItemID = string | number;

export enum ItemsFetchMode {
  active = "active",
  archived = "archived",
  all = "all",
}

